module.exports = __webpack_public_path__ + "img/btn-rgb.05e443a2.png";